 <template>
  <v-dialog v-model="dialog" persistent max-width="550px" scrollable>
    <v-card>
      <v-toolbar dark dense flat>
        <v-toolbar-title class="headline">{{
          editedIndex == -1
            ? "New order detail product"
            : "Edit order detail product"
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('dialog', false) && $emit('setEditIndex', -1)"
          >close</v-icon
        >
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-autocomplete
            v-model="store_search"
            :items="store_list"
            :loading="isLoadingStore"
            :search-input.sync="searchStore"
            color="black"
            hide-no-data
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Select store"
            placeholder="Start to Search"
            return-object
            :disabled="true"
          ></v-autocomplete>

          <v-layout row wrap v-if="store_search != null">
            <v-flex xs8 sm9 class="pr-1">
              <!-- <v-autocomplete
                v-model="product_search"
                :items="product_by_store_list"
                :loading="isLoadingProduct"
                :search-input.sync="searchProduct"
                color="black"
                hide-no-data
                hide-selected
                item-text="product_name_th"
                item-value="product_id"
                label="Select Product"
                placeholder="Start to Search"
                return-object
              ></v-autocomplete>-->
              <v-autocomplete
                label="Select Product"
                placeholder="Start to Search"
                :items="product_by_store_list"
                v-model="product_search"
                :loading="isLoadingProduct"
                :search-input.sync="searchProduct"
                color="black"
                hide-no-data
                hide-selected
                item-text="product_name_th"
                item-value="product_id"
                return-object
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.product_name_th"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.product_name_en"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action
                      >THB
                      {{ data.item.product_base_price }}</v-list-tile-action
                    >
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs4 sm3 class="pl-1">
              <v-text-field
                v-model.number="form.order_detail_amount"
                label="Amount"
                hide-details
                color="black"
                type="number"
                :rules="[(v) => !!v || 'Amount is required']"
              ></v-text-field>
              <!-- v-if="isLoadingOption == false && isLoadingProduct == false && product_search != null" -->
            </v-flex>
          </v-layout>

          <v-layout row wrap class="pl-2" v-if="isLoadingOption == true">
            <v-spacer />
            <v-progress-circular
              :size="30"
              :width="5"
              color="primary"
              indeterminate
              class="ma-3"
            ></v-progress-circular>
            <v-spacer />
          </v-layout>
          <v-layout
            row
            wrap
            class="pl-2"
            v-if="
              product_search != null &&
              option_by_product_list &&
              typeof option_by_product_list === 'object' &&
              option_by_product_list.constructor === Array &&
              option_by_product_list.length == 0 &&
              isLoadingOption == false
            "
          >
            <v-spacer />No Option
            <v-spacer />
          </v-layout>
          <v-layout
            row
            wrap
            class="pl-2"
            v-if="
              product_search != null &&
              option_by_product_list &&
              typeof option_by_product_list === 'object' &&
              option_by_product_list.constructor === Array &&
              option_by_product_list.length != 0 &&
              isLoadingOption == false
            "
          >
            <v-flex xs4 class="pr-2">
              <div
                v-for="(items, index) in option_by_product_list"
                :key="index"
              >
                <div
                  class="mt-3"
                  style="font-size: 16px"
                  v-if="(index + 1) % 3 === 1"
                >
                  <v-card class="pa-2">
                    Option {{ index + 1 }} : {{ items.option_name_th }}
                    <br />
                    <div v-if="items.option_require == true">
                      (บังคับเลือก)
                      <br />
                    </div>
                    <!-- <span>{{items.option_require == true ? '(บังคับเลือก)' : null}}</span><br> -->
                    <v-radio-group
                      v-model="item_option.single[index]"
                      column
                      hide-details
                      style="margin-top: 4px"
                      v-if="items.option_type == 1"
                    >
                      <v-radio
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        :value="info"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-radio>
                    </v-radio-group>
                    <div v-if="items.option_type == 2">
                      <v-checkbox
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        v-model="item_option.multiple"
                        :value="info"
                        hide-details
                        style="margin-top: 4px"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-checkbox>
                      {{ valid_checkbox == true ? "กรุณาเลือก" : null }}
                    </div>
                  </v-card>
                </div>
              </div>
            </v-flex>
            <v-flex xs4 class="pr-2">
              <div
                v-for="(items, index) in option_by_product_list"
                :key="index"
              >
                <div
                  class="mt-3"
                  style="font-size: 16px"
                  v-if="(index + 1) % 3 === 2"
                >
                  <v-card class="pa-2">
                    Option {{ index + 1 }} : {{ items.option_name_th }}
                    <br />
                    <div v-if="items.option_require == true">
                      (บังคับเลือก)
                      <br />
                    </div>
                    <v-radio-group
                      v-model="item_option.single[index]"
                      column
                      hide-details
                      style="margin-top: 4px"
                      v-if="items.option_type == 1"
                    >
                      <v-radio
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        :value="info"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-radio>
                    </v-radio-group>
                    <div v-if="items.option_type == 2">
                      <v-checkbox
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        v-model="item_option.multiple"
                        :value="info"
                        hide-details
                        style="margin-top: 4px"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-checkbox>
                    </div>
                  </v-card>
                </div>
              </div>
            </v-flex>
            <v-flex xs4 class="pr-2">
              <div
                v-for="(items, index) in option_by_product_list"
                :key="index"
              >
                <div
                  class="mt-3"
                  style="font-size: 16px"
                  v-if="(index + 1) % 3 === 0"
                >
                  <v-card class="pa-2">
                    Option {{ index + 1 }} : {{ items.option_name_th }}
                    <br />
                    <div v-if="items.option_require == true">
                      (บังคับเลือก)
                      <br />
                    </div>
                    <v-radio-group
                      v-model="item_option.single[index]"
                      column
                      hide-details
                      style="margin-top: 4px"
                      v-if="items.option_type == 1"
                    >
                      <v-radio
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        :value="info"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-radio>
                    </v-radio-group>
                    <div v-if="items.option_type == 2">
                      <v-checkbox
                        color="green"
                        :label="
                          info.choice_name_th + ' ' + info.choice_price + '฿'
                        "
                        v-model="item_option.multiple"
                        :value="info"
                        hide-details
                        style="margin-top: 4px"
                        v-for="info in items.option_choice"
                        :key="info.choice_id"
                      ></v-checkbox>
                    </div>
                  </v-card>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-textarea
            v-model="product_note"
            name="Product note"
            label="Product note"
            value
            rows="1"
            v-if="
              isLoadingOption == false &&
              isLoadingProduct == false &&
              product_search != null
            "
          ></v-textarea>
          <!-- </v-layout> -->
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="red" flat @click="reset()">reset</v-btn>
        <v-btn color="green" class="black--text" @click="save()">save</v-btn>
        <span transition="fade">
          <v-icon color="green" v-if="update_loading == 2">check</v-icon>
          <v-icon color="red" v-if="update_loading == 3">close</v-icon>
          <v-progress-circular
            :width="3"
            :size="15"
            indeterminate
            color="grey"
            v-if="update_loading == 1"
          ></v-progress-circular>
          {{
            update_loading == 1
              ? "Updating"
              : update_loading == 2
              ? "Update successfully"
              : update_loading == 3
              ? "Cant update"
              : null
          }}
        </span>
        <v-spacer />
      </v-card-actions>
      <v-divider />
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
export default {
  props: [
    "order_status_id",
    "dialog",
    "editedIndex",
    "original_option",
    "original_data",
    "form",
  ],
  data() {
    return {
      product_note: null,
      isLoadingOption: false,
      option_by_product_list: [],
      product_by_store_list: [],
      isLoadingProduct: false,
      isLoadingStore: false,
      model: null,
      searchProduct: null,
      searchStore: null,
      valid_checkbox: false,
      valid: true,
      update_loading: 0,
      item_option: { single: [], multiple: [] },
      product_search: null,
      product_search_name: "",
      store_search_name: "",
      store_search: null,
      store_type_search_id: 0,
    };
  },
  watch: {
    searchProduct(val) {
      this.productSearch();
    },
    searchStore(val) {
      this.storeSearch();
    },
    async dialog() {
      if (this.dialog == false) {
        this.$refs.form.reset();
        this.product_search_name = "";
        this.store_search_name = "";
        this.isLoadingProduct = false;
      } else {
        this.product_note = null;
        this.update_loading = 0;
        this.isLoadingStore = true;
        this.$store.commit("fetchStoreBack/getStoreList", []);
        await this.$store.dispatch("fetchStoreBack/getStoreList");
        this.isLoadingStore = false;
        if (this.editedIndex == -1) {
          // if (this.order_detail.order_type == 3) {
          for (let val of this.store_list) {
            if (val.store_id == this.original_data.order_detail_store_id) {
              this.store_search = val;
            }
          }
          await this.productSearch();
          // }
        } else if (this.editedIndex != -1) {
          for (let val of this.store_list) {
            if (val.store_id == this.original_data.order_detail_store_id) {
              this.store_search = val;
            }
          }
          await this.productSearch();
          for (let val of this.product_by_store_list) {
            if (
              val.product_id ==
              this.original_data.order_detail_product.product_id
            ) {
              this.product_search = val;
            }
          }
          this.item_option = Object.assign({}, this.original_option);
          if (this.original_data.order_detail_product.product_note) {
            this.product_note = this.original_data.order_detail_product.product_note;
          }
        }
      }
    },
    store_search() {
      this.product_by_store_list = [];
      this.product_search = null;
      this.reset();
    },
    async product_search() {
      if (this.product_search != null) {
        this.isLoadingOption = true;
        this.option_by_product_list = [];
        this.option_by_product_list = await this.$store.dispatch(
          "fetchOrderDetailBack/getOptionByProduct",
          this.product_search.product_id
        );
        this.isLoadingOption = false;
      }
      if (this.editedIndex == -1) {
        this.item_option.multiple = [];
        this.item_option.single = [];
      } else {
        if (
          this.product_search.product_id !=
          this.original_data.order_detail_product.product_id
        ) {
          this.item_option.multiple = [];
          this.item_option.single = [];
        } else {
          this.item_option = Object.assign({}, this.original_option);
          this.form.order_detail_amount = this.original_data.order_detail_amount;
        }
      }
    },
  },
  computed: {
    ...mapState({
      store_type: (state) => state.fetchOrderDetailBack.store_type,
      order_detail: (state) => state.fetchOrderDetailBack.order_detail,
    }),
    ...mapGetters({
      store_list: "fetchStoreBack/autocompleteStore",
    }),
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
  },
  methods: {
    async productSearch() {
      // Items have already been loaded
      if (this.product_by_store_list.length > 0) return;

      // Items have already been requested
      if (this.isLoadingProduct) return;

      this.isLoadingProduct = true;
      // Lazily load input items
      let product_search = await this.$store.dispatch(
        "fetchOrderDetailBack/getProductByStore",
        this.store_search.store_id
      );
      for (let val of product_search) {
        val.product_name_en = val.product_name_en || "";
        val.product_name_th = val.product_name_th || "";
      }
      this.product_by_store_list = product_search;
      this.isLoadingProduct = false;
    },
    async storeSearch() {
      // Items have already been loaded
      if (this.store_list.length > 0) return;

      // Items have already been requested
      if (this.isLoadingStore) return;
      // this.isLoadingStore = true;
      // await this.$store.dispatch("fetchStoreBack/getStoreList");
      // this.isLoadingStore = false;
    },
    takeOption(order_detail_option, val) {
      for (let val2 of this.option_by_product_list) {
        if (val.choice_option_id == val2.option_id) {
          let data = {
            order_option_id: null,
            order_option_order_detail_id: null,
            order_option_order_point: null,
            order_option_price: null,
            order_option_option_choice: {
              option_id: val2.option_id,
              option_name_th: val2.option_name_th,
              option_name_en: val2.option_name_en,
              option_name_cn: null,
              option_require: val2.option_require,
              option_type: val2.option_type,
              option_choice: [],
            },
          };
          let obj1 = Object.assign({}, val);
          delete obj1.choice_option_id;
          data.order_option_option_choice.option_choice.push(obj1);
          let a = order_detail_option.some(
            (item) =>
              item.order_option_option_choice.option_id ===
              data.order_option_option_choice.option_id
          );
          if (a == false) {
            order_detail_option.push(data);
          } else {
            let index = order_detail_option.findIndex(
              (item) =>
                item.order_option_option_choice.option_id ==
                data.order_option_option_choice.option_id
            );
            let obj2 = Object.assign({}, val);
            delete obj2.choice_option_id;
            order_detail_option[
              index
            ].order_option_option_choice.option_choice.push(obj2);
          }
        }
      }
      return order_detail_option;
    },
    takeProductDetail() {
      this.form.order_detail_product = {};
      for (let val of this.product_by_store_list) {
        if (this.product_search.product_id == val.product_id) {
          let obj1 = Object.assign({}, val);
          delete obj1.product_detail;
          delete obj1.product_store_id;
          this.form.order_detail_product = obj1;
        }
      }
      this.form.order_detail_product.product_note = this.product_note;
    },
    takeStoreDetail() {
      for (let val of this.store_list) {
        if (this.store_search.store_id == val.store_id) {
          this.form.order_detail_store = val.store_name_th;
          this.form.order_detail_store_id = val.store_id;
        }
      }
    },
    takePrice() {
      let order_detail_total_option_price = 0;
      for (let val of this.form.order_detail_order_option) {
        let order_option_price = 0;
        for (let val2 of val.order_option_option_choice.option_choice) {
          order_option_price += parseFloat(val2.choice_price);
        }
        val.order_option_price = order_option_price;
        order_detail_total_option_price += order_option_price;
      }
      this.form.order_detail_product_seller_price = this.form.order_detail_product.product_sale_price;
      this.form.order_detail_total_option_price = order_detail_total_option_price;
      this.form.order_detail_total_product_price =
        (this.form.order_detail_product_seller_price +
          this.form.order_detail_total_option_price) *
        this.form.order_detail_amount;
      for (let val of this.store_list) {
        if (val.store_id == this.form.order_detail_store_id) {
          this.form.order_detail_vat_price =
            (this.form.order_detail_total_product_price * val.store_vat) / 100;
          this.form.order_detail_service_charge_price =
            (this.form.order_detail_total_product_price *
              val.store_service_charge) /
            100;
        }
      }
    },
    takeIDOption(order_detail_option) {
      for (let val of this.original_data.order_detail_order_option) {
        for (let val2 of order_detail_option) {
          if (
            val.order_option_option_choice.option_id ==
            val2.order_option_option_choice.option_id
          ) {
            val2.order_option_id = val.order_option_id;
          }
        }
      }
      return order_detail_option;
    },
    cutID(order_detail_option) {
      for (let val of order_detail_option) {
        if (val.order_option_id == null) {
          delete val.order_option_id;
        }
        if (this.editedIndex == -1) {
          delete val.order_option_order_detail_id;
        } else {
          val.order_option_order_detail_id = this.original_data.order_detail_id;
        }
      }
      return order_detail_option;
    },
    validationCheckbox() {
      let b = [];
      for (let val of this.option_by_product_list) {
        if (val.option_require == true && val.option_type == 2) {
          let a = this.item_option.multiple.some(
            (item) => item.choice_option_id == val.option_id
          );
          if (a == false) {
            b.push(val.option_id);
          }
        }
      }
      if (b.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    validationRadio() {
      let b = [];
      for (let val of this.option_by_product_list) {
        if (val.option_require == true && val.option_type == 1) {
          let a = this.item_option.single.some(
            (item) => item.choice_option_id == val.option_id
          );
          if (a == false) {
            b.push(val.option_id);
          }
        }
      }
      if (b.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    async save() {
      if (
        this.$refs.form.validate() &&
        this.validationCheckbox() &&
        this.validationRadio()
      ) {
        let order_detail_option = [];
        for (let val of this.item_option.multiple) {
          order_detail_option = this.takeOption(order_detail_option, val);
        }
        for (let val of this.item_option.single) {
          if (val != undefined) {
            order_detail_option = this.takeOption(order_detail_option, val);
          }
        }
        if (this.editedIndex != -1) {
          order_detail_option = this.takeIDOption(order_detail_option);
        }
        order_detail_option = this.cutID(order_detail_option);
        this.form.order_detail_order_option = order_detail_option;
        this.takeProductDetail();
        this.takeStoreDetail();
        this.takePrice();
        if (this.editedIndex == -1) {
          let obj_clone = await JSON.parse(JSON.stringify(this.form));
          this.$emit("dialog", false);
          await this.$store.dispatch(
            "fetchOrderDetailBack/createItem",
            obj_clone
          );
          await this.$store.dispatch(
            "fetchOrderListBack/getOrderList",
            this.order_status_id
          );
          this.$emit("cloneOrder");
        } else {
          this.update_loading = 1;
          this.update_loading = await this.$store.dispatch(
            "fetchOrderDetailBack/updateItem",
            this.form
          );
          this.$emit("cloneOrder");
          this.$emit("dialog", false);
          this.$emit("setEditIndex", -1);
          await this.$store.dispatch(
            "fetchOrderListBack/getOrderList",
            this.order_status_id
          );
        }
      } else {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
    },
    reset() {
      this.item_option.multiple = [];
      this.item_option.single = [];
      this.form.order_detail_amount = null;
    },
  },
};
</script>

<style scoped>
.gallery {
  background-color: pink;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.checkContent {
  width: 100%;
  word-break: break-all;
  border: 1px solid black;
  margin-bottom: 1rem;
}
</style>